import { getApi } from "../apiCall";

export const getBilateralLedgerOngoing = (currentPage = 0, size = 100) => {
  const url = `${process.env.REACT_APP_API_URL}/bsbp/connection/unified-ledgers?currentPage=${currentPage}&size=${size}`;
  return getApi(url);
};

export const getRALedgerOngoing = (currentPage = 0, size = 100) => {
  const url = `${process.env.REACT_APP_API_URL}/bsra/tender/terms-and-closed?page=${currentPage}&size=${size}`;
  return getApi(url);
};

export const getCBLedgerOngoing = ({
  currentPage = 0,
  size = 100,
  tenderType = "CB",
}) => {
  const url = `${process.env.REACT_APP_API_URL}/bsra/tender/terms-and-closed?page=${currentPage}&size=${size}&tenderType=${tenderType}`;
  return getApi(url);
};
